import React from 'react';
import eacoLogo from '@/assets/eaco-logo.svg';

/**
 * Shared "Powered by Eaco" footer for every public-form surface — the fill
 * page and the terminal screens (submitted / already-submitted / closed /
 * not-found) — so the attribution is consistent across the whole flow.
 */
const PoweredByEaco: React.FC = () => (
  <footer className="flex-none pb-2 pt-1.5">
    <a
      href="https://eaco.me"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center gap-2 text-xs text-muted-foreground transition-colors hover:text-foreground"
    >
      <span>Powered by</span>
      <img src={eacoLogo} alt="Eaco" className="h-4 w-auto" />
    </a>
  </footer>
);

export default PoweredByEaco;
